var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7647 8.15526L34.6147 1M41.7647 16.5732L26.2029 1M41.7647 24.9588L17.7912 1M41.7647 33.3767L9.41176 1M41.7647 41.7623L1 1M33.3529 41.7623L1 9.41795M24.9412 41.7623L1 17.8035M16.5618 41.7623L1 26.2215M8.15 41.7623L1 34.6071",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareWhite);
export default __webpack_public_path__ + "static/media/square_white.f4ba833c6117d1e4e1bb1ffdd0ba4430.svg";
export { ForwardRef as ReactComponent };